<template>
    <div>
        <my-search v-model="pgData" @search="searchHandler()">
            <el-form-item slot="title">
                <el-input v-model="pgData.txtkey"  placeholder="招标项目名称" clearable></el-input>
            </el-form-item>
            <el-form-item slot="time">

            </el-form-item>
        </my-search>
        <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="招标项目名称" prop="zbproname"></el-table-column>
            <el-table-column label="招标项目编号" prop="zbprocode"></el-table-column>
            <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                    <el-button type="warning" size="mini" icon="el-icon-check"  @click="closedialog(scope)">选择</el-button>
                </template>
            </el-table-column>
        </my-table>
        <my-pagination ref="page" v-model="tableData"  :search="pgData" :action="`${getGetters('mngUrl')}/manage/business/xgsq/get_zbxmlist.json`">
        </my-pagination>
    </div>
</template>

<script>
import FORM_PAGE_MIXIN from "@views/mixins/form-page";
export default {
    mixins: [FORM_PAGE_MIXIN],
    data() {
        return{
            tableHeight:'450',
            tableData:[],
            pgData:{
                a:'111'
            },
            dialogVisible:false,
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {
        // 提交
        fSave:function(id){

        },
        closedialog:function(scope){
            this.$emit("close",false);
            this.$emit("getzbpro",scope.row);
        },
        searchHandler:function(){
            var that=this;
            that.$get(`${this.getGetters('mngUrl')}/manage/business/xgsq/get_zbxmlist.json`,that.pgData, (data, res) => {
                that.tableData=data.rows;
            });
        }
    },
    created() {
        
    },
    mounted() {
        
    }
}
</script>

<style scoped lang="scss">

</style>
